import { httpPost } from "utils/httpRequest"

const listBadges = async () => {
  const resp = await httpPost("admin/badge/list", {})
  return resp.data
}

const createBadge = async ({ key, name, description, iconUrl, color }) => {
  const resp = await httpPost("admin/badge/create", { key, name, description, iconUrl, color })
  return resp.data
}

const updateBadge = async ({ id, key, name, description, iconUrl, color }) => {
  const resp = await httpPost("admin/badge/update", { id, key, name, description, iconUrl, color })
  return resp.data
}

const deleteBadge = async ({ id }) => {
  const resp = await httpPost("admin/badge/delete", { id })
  return resp.data
}

const getMemberBadges = async ({ memberId }) => {
  const resp = await httpPost("admin/member/badges/get", { memberId: parseInt(memberId) })
  return resp.data
}

const updateMemberBadges = async ({ memberId, badges }) => {
  const resp = await httpPost("admin/member/badges/update", {
    memberId: parseInt(memberId),
    badges,
  })
  return resp.data
}

export { listBadges, createBadge, updateBadge, deleteBadge, getMemberBadges, updateMemberBadges }

